import React from 'react'
import { OverlayTrigger, Popover, Row, Tooltip } from 'react-bootstrap'
import DisplayItem from '../DisplayItems/DisplayItem'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { faQuestionCircle } from '@fortawesome/pro-duotone-svg-icons/faQuestionCircle'

import DisplayItemForm from '../Form/DisplayItemForm'
import DefDossierDefFieldForm from '../Form/DefDossierDefFieldForm'
import DefFieldForm from '../Form/DefFieldForm'
import DefDossierLinkForm from '../Form/DefDossierLinkForm'
import AdminQuickEditMenu from '../Elements/AdminQuickEditMenu'
import { Link } from 'react-router-dom'
import DOMPurify from 'dompurify'
import ConfirmRedirectWebpageDialog from '../Form/ConfirmRedirectWebpageDialog'

class DefaultGrid extends React.Component {
    constructor(props) {
        super(props)

        for (let i = 0; i < props.items.length; i++) {
            this['ddiRef' + props.items[i].id] = React.createRef()
        }

        this.state = {
            confirmRedirect: null,
            docheck: false,
            firstcheck: false,
            withoutEdit: this.props.withoutEdit
                ? this.props.withoutEdit
                : false,
        }

        this.doFocus = this.doFocus.bind(this)
        this.onCancel = this.onCancel.bind(this)
        this.recheckConditions = this.recheckConditions.bind(this)
        this.whitelist = ['kedo.nu', 'kedonext.com'];
    }

    doFocus(errorId) {
        if (
            !this['ddiRef' + errorId] ||
            !this['ddiRef' + errorId].current ||
            !this['ddiRef' + errorId].current.ddiRef
        ) {
            return
        }

        this['ddiRef' + errorId].current.ddiRef.current.doFocus(errorId)
    }

    onCancel() {
        let filtered = this.props.items.filter(
            (item) => item.view === 'edit' || item.view === 'show/edit'
        )

        filtered.map((filterItem) => {
            if (
                (filterItem.def_dossier_link &&
                    filterItem.def_dossier_link.type_of_link === 'select') ||
                (filterItem.def_dossier_def_field &&
                    filterItem.def_dossier_def_field.def_field &&
                    (filterItem.def_dossier_def_field.def_field.type ===
                        'user' ||
                        filterItem.def_dossier_def_field.def_field.type ===
                            'list'))
            ) {
                this['ddiRef' + filterItem.id].current.ddiRef.current.onCancel()
            }
        })
    }

    getValues() {
        let values = {}
        let filtered = this.props.items.filter(
            (item) => item.view === 'edit' || item.view === 'show/edit'
        )

        filtered.map((filterItem) => {
            if (
                this['ddiRef' + filterItem.id].current &&
                this['ddiRef' + filterItem.id].current.ddiRef &&
                this['ddiRef' + filterItem.id].current.ddiRef.current &&
                this['ddiRef' + filterItem.id].current.ddiRef.current.getValue
            ) {
                values[filterItem.id] =
                    this[
                        'ddiRef' + filterItem.id
                    ].current.ddiRef.current.getValue()
            }
        })

        return values
    }

    isObligatory(item) {
        if (
            item.def_dossier_def_field &&
            item.def_dossier_def_field.obligatory &&
            item.def_dossier_def_field.obligatory === true
        ) {
            return true
        }

        if (
            item.def_dossier_link &&
            item.def_dossier_link.obligatory === true
        ) {
            return true
        }

        if (this.props.conditions) {
            let values = this.getValues()
            let condResult = false
            this.props.conditions.map((condition) => {
                if (this.conditionMatches(condition, values)) {
                    if (
                        condition.actions
                            .filter(
                                (action) => action.action === 'require_fields'
                            )
                            .filter((action) =>
                                action.values.find(
                                    (actVal) => actVal === item.id
                                )
                            ).length > 0
                    ) {
                        condResult = true
                    }
                }
            })

            return condResult
        }

        return false
    }

    isEditMode() {
        if (this.props.mode === 'edit' || this.props.mode === 'show/edit') {
            return true
        }

        if (this.props.mode === 'show/edit') {
            return true
        }

        return false
    }

    getTranslationFromItem(item) {
        if (!item.translations || item.translations.length <= 0) {
            return
        }

        let locale = this.props.kedo.env().getSelectedLocale()
        let trans = item.translations.find(
            (trans) => trans.culture === locale.code
        )

        if (!trans && item.translations.length > 0) {
            trans = item.translations[0]
        }

        return trans
    }

    replaceSpecialTags(preText) {
        if (preText.indexOf('{') === false) {
            return preText
        }
        // eslint-disable-next-line
        let parts = preText.split(/\{dossier\:([0-9]+)\}/g)
        for (var i = 1; i < parts.length; i += 2) {
            parts[i] = (
                <Link target={'_new'} to={`/contentdossier/${parts[i]}`}>
                    {parts[i]}
                </Link>
            )
        }

        return <div>{parts}</div>
    }

    renderPreText(item) {
        let trans = this.getTranslationFromItem(item)

        if (
            this.props.mode === 'search' ||
            this.props.mode === 'advanced-search'
        ) {
            return
        }

        if (!trans || !trans.settings || !trans.settings.pretext) {
            return
        }

        return (
            <span className={'PreText'}>
                {this.replaceSpecialTags(trans.settings.pretext)}
            </span>
        )
    }

    renderInformationText(translation, show_info_direct) {
        if (
            !translation ||
            !translation.settings ||
            !translation.settings.informationtext
        ) {
            return null
        }

        let settings = {
            ALLOWED_TAGS: [
                'a',
                'b',
                'img',
                'br',
                'span',
                'table',
                'ol',
                'tbody',
                'li',
                'i',
                'strong',
                'tr',
                'td',
                'thead',
                'div',
                'p',
            ],
            ALLOWED_ATTR: ['style', 'href', 'border', 'src', 'width', 'heigth'],
        }

        return (
            <div
                ref={(dom) => {
                    if (dom) {
                        dom.querySelectorAll('a').forEach((link) => {
                            link.addEventListener('click', (e) => {
                                if (e.target.tagName === 'A' && e.target.href) {
                                    const url = new URL(e.target.href);
                                    const isWhitelisted = this.whitelist.some(domain => url.hostname.endsWith(domain));

                                    if (!isWhitelisted) {
                                        e.preventDefault();
                                        this.setState({ confirmRedirect: e.target.href });
                                    }
                                }
                            })
                        })
                    }
                }}
                style={{display: 'inline-block'}}
            >
                {show_info_direct ? (
                    <div
                        dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(
                                translation.settings.informationtext,
                                settings
                            ).replace(/&nbsp;/g, ' '),
                        }}
                    />
                ) : (
                    <OverlayTrigger
                        key={translation.id + '-help'}
                        placement={'auto'}
                        overlay={
                            translation.settings.informationtext.includes(
                                '\n'
                            ) ? (
                                <Popover
                                    id={`pop-${translation.id}`}
                                    className="popOver"
                                >
                                    <Popover.Content className="popOverMoreContent">
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: DOMPurify.sanitize(
                                                    translation.settings
                                                        .informationtext,
                                                    settings
                                                ),
                                            }}
                                        />
                                    </Popover.Content>
                                </Popover>
                            ) : (
                                <Popover
                                    id={`pop-${translation.id}`}
                                    className="popOver"
                                >
                                    <Popover.Content className="popOverContent">
                                        <div
                                            className="popOverDiv"
                                            dangerouslySetInnerHTML={{
                                                __html: DOMPurify.sanitize(
                                                    translation.settings
                                                        .informationtext,
                                                    settings
                                                ),
                                            }}
                                        />
                                    </Popover.Content>
                                </Popover>
                            )
                        }
                    >
                        <span>
                            <FontAwesomeIcon icon={faQuestionCircle} />
                        </span>
                    </OverlayTrigger>
                )}
            </div>
        )
    }

    renderLabel(item) {
        if (this.props.custom_layout === 'row_input') {
            return null
        }

        if (!item.translations || item.translations.length <= 0) {
            return item.id
        }

        if (
            this.props.embedded &&
            item.def_dossier_link &&
            item.def_dossier_link.id === this.props.linkId
        ) {
            return null
        }

        let trans = this.getTranslationFromItem(item)

        //No label for embeddedLink display item if we are creating a new dossier.
        if (
            !this.props.dossier &&
            item.def_dossier_link &&
            item.def_dossier_link.type_of_link === 'embeddedList' &&
            this.props.mode !== 'search'
        ) {
            if (trans.length <= 0) {
                return ''
            }
        }

        return (
            <>
                <h6 data-ddiid={item.id}>
                    {trans.name ? trans.name : ''}&nbsp;
                    {this.isEditMode() && this.isObligatory(item) ? (
                        <span style={{ color: '#F38B8F' }}>*</span>
                    ) : (
                        ''
                    )}
                    &nbsp;
                    {!item.settings?.show_info_direct &&
                        this.renderInformationText(
                            trans,
                            item.settings?.show_info_direct
                        )}
                    <AdminQuickEditMenu kedo={this.props.kedo} item={item} />
                </h6>
                {item.settings?.show_info_direct &&
                    this.renderInformationText(
                        trans,
                        item.settings.show_info_direct
                    )}
                <AdminQuickEditMenu kedo={this.props.kedo} item={item} />
            </>
        )
    }

    getMinimalColspan(item) {
        let minColSpan = 12
        if (window.innerWidth < 576) {
            minColSpan = 12
        }
        if (
            window.innerWidth > 576 &&
            window.innerWidth < 768 &&
            item.colspan < 6
        ) {
            minColSpan = 6
        }
        if (
            window.innerWidth > 768 &&
            window.innerWidth < 992 &&
            item.colspan < 4
        ) {
            minColSpan = 4
        }
        if (
            window.innerWidth > 992 &&
            window.innerWidth < 1200 &&
            item.colspan < 2
        ) {
            minColSpan = 2
        }
        if (window.innerWidth > 1200) {
            minColSpan = 1
        }

        if (item.colspan < minColSpan) {
            return minColSpan
        }

        return item.colspan
    }

    recheckConditions() {
        let check = !this.state.docheck
        this.setState({ docheck: check })
    }

    conditionRuleFieldMatches(fieldRule, values) {
        let value = values[fieldRule.field]
        let result = false
        if (fieldRule.field_method === 'equals') {
            fieldRule.values.map((fieldRuleValId) => {
                if (
                    value &&
                    value.find &&
                    value.find(
                        (listOptionId) => listOptionId === fieldRuleValId
                    )
                ) {
                    result = true
                }
            })
        } else if (fieldRule.field_method === 'notequals') {
            fieldRule.values.map((fieldRuleValId) => {
                if (
                    (value &&
                        value.find &&
                        value.find(
                            (listOptionId) => listOptionId !== fieldRuleValId
                        )) ||
                    (value && value.length <= 0)
                ) {
                    result = true
                }
            })
        }

        return result
    }

    conditionMatches(condition, values) {
        let result = false
        let conditionRuleMatches = condition.rules.filter((rule) => {
            let wantLength = rule.type === 'or' ? 1 : rule.fields.length
            return (
                rule.fields.filter((ruleField) =>
                    this.conditionRuleFieldMatches(ruleField, values)
                ).length >= wantLength
            )
        })

        if (conditionRuleMatches.length > 0) {
            return true
        }

        return result
    }

    checkCondition(conditions, hiddenfields, item, condAct = 'show_fields') {
        if (!conditions || !hiddenfields || conditions.length <= 0) {
            return true
        }
        let result = !hiddenfields.find((hiddenId) => hiddenId === item.id)

        if (result) {
            return true
        }

        let values = this.getValues()

        conditions.map((condition) => {
            if (this.conditionMatches(condition, values)) {
                if (
                    condition.actions
                        .filter((action) => action.action === condAct)
                        .filter((action) =>
                            action.values.find((actVal) => actVal === item.id)
                        ).length > 0
                ) {
                    result = true
                }
            }
        })

        return result
    }

    shouldListenForConditions(conditions, item) {
        if (!conditions || conditions.length <= 0) {
            return false
        }
        let result = false
        conditions.map((condition) => {
            condition.rules.map((rule) => {
                if (rule.fields.find((field) => field.field === item.id)) {
                    result = true
                }
            })
        })

        return true
    }

    isView(currentView, itemView) {
        if (
            currentView === 'show' &&
            (itemView === 'show' || itemView === 'show/edit')
        ) {
            return true
        }

        if (
            currentView === 'edit' &&
            (itemView === 'edit' || itemView === 'show/edit')
        ) {
            return true
        }

        return currentView === itemView
    }

    returnContent(displayItem) {
        if (!this.props.content) return null

        if (
            this.props.mode === 'search' ||
            this.props.mode === 'advanced-search'
        ) {
            let contentObject = {}
            this.props.content.forEach(
                (item) => (contentObject[item.id] = item.value)
            )

            return contentObject[displayItem.id]
        } else {
            return this.props.content[displayItem.id]
        }
    }

    renderDisplayItems() {
        const {
            mode,
            items,
            custom_layout,
            settings,
            defDossierSettings,
            conditions,
            hiddenfields,
            errors,
            onKeyPress,
        } = this.props
        const { firstcheck } = this.state

        let lastRank = null

        const companyLookup =
            defDossierSettings?.address_company_settings?.company_lookup ||
            settings?.address_company_settings?.company_lookup
        const defAddressCompanySettings =
            defDossierSettings?.address_company_settings
        const addressCompanySettings = settings?.address_company_settings

        const shouldRenderItem = (item) => {
            if (
                firstcheck &&
                !this.checkCondition(conditions, hiddenfields, item)
            )
                return false
            if (
                this.isEditMode() &&
                item.def_dossier_def_field?.def_field?.type === 'autoIncrement'
            )
                return false
            return true
        }

        const updateItemSettings = (
            item,
            addressCompanySettings,
            defAddressCompanySettings
        ) => {
            const validationRules = [
                { key: 'kvkNummer', value: item.id },
                { key: 'straatnaam', value: item.id },
                { key: 'vestigingsnummer', value: item.id },
                { key: 'zipcode', value: item.id },
            ]

            const isValid = validationRules.some((rule) => {
                const addressValue = addressCompanySettings?.[rule.key]
                const defAddressValue = defAddressCompanySettings?.[rule.key]
                return (
                    addressValue == rule.value || defAddressValue == rule.value
                )
            })

            if (isValid) {
                const settings =
                    addressCompanySettings ?? defAddressCompanySettings
                item.settings = {
                    ...item.settings,
                    ...settings,
                }
            }
        }

        if (!firstcheck) {
            setTimeout(() => this.setState({ firstcheck: true }), 150)
        }

        return items
            .filter((item) => this.isView(mode, item.view))
            .sort((a, b) => a.rank - b.rank)
            .reduce((acc, item, index) => {
                if (!shouldRenderItem(item)) return acc

                companyLookup &&
                    updateItemSettings(
                        item,
                        addressCompanySettings,
                        defAddressCompanySettings
                    )

                const breakClassLine =
                    lastRank !== null && item.rank !== lastRank
                        ? 'w-100 d-none d-md-block'
                        : ''
                lastRank = item.rank

                const cssClassName =
                    custom_layout === 'row_input'
                        ? 'displayGrid'
                        : `displayGrid col-xs-12 col-md-${this.getMinimalColspan(
                              item
                          )} ${
                              ['search', 'advanced-search'].includes(mode)
                                  ? 'search-item'
                                  : ''
                          }`

                acc.push(
                    <>
                        {breakClassLine && <div className={breakClassLine} />}
                        <div
                            key={item.id}
                            className={cssClassName}
                            style={
                                custom_layout === 'row_input' &&
                                (item?.def_dossier_def_field?.def_field.type ===
                                    'list' ||
                                    (item?.def_dossier_link?.id > 0 &&
                                        item.settings?.enable_small_view))
                                    ? { minWidth: '200px' }
                                    : null
                            }
                        >
                            {this.renderPreText(item)}
                            {this.renderLabel(item)}
                            <DisplayItem
                                changeValue={this.props.changeValue}
                                conditions={conditions}
                                content={this.returnContent(item)}
                                dossier={this.props.dossier}
                                errors={errors?.[item.id] ?? null}
                                item={item}
                                kedo={this.props.kedo}
                                embedded={this.props.embedded}
                                linkId={this.props.linkId}
                                mode={mode}
                                custom_layout={custom_layout}
                                onKeyPress={onKeyPress || null}
                                recheckConditions={this.recheckConditions}
                                ref={this['ddiRef' + item.id]}
                                shoudListenForConditions={this.shouldListenForConditions(
                                    conditions,
                                    item
                                )}
                                settings={settings}
                            />
                        </div>
                    </>
                )

                return acc
            }, [])
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if (
            this.props.items.length !== nextProps.items.length ||
            this.props.mode !== nextProps.mode
        ) {
            return true
        }
        if (
            this.state.docheck !== nextState.docheck ||
            this.state.firstcheck !== nextState.firstcheck
        ) {
            return true
        }
        if (
            nextProps.errors &&
            this.props.errors.length !== nextProps.errors.length
        ) {
            return true
        }

        return true
    }

    render() {
        if (this.props.multiUpdate) {
            this.props?.items.map((item) => {
                if (
                    item &&
                    item.def_dossier_def_field &&
                    item.def_dossier_def_field.obligatory === true
                ) {
                    item.def_dossier_def_field.obligatory = false
                }

                if (
                    item &&
                    item.def_dossier_def_field &&
                    item.def_dossier_def_field.def_field &&
                    item.def_dossier_def_field.def_field.def_field_lists
                ) {
                    item.def_dossier_def_field.def_field.def_field_lists.map(
                        (items) => {
                            items.default = false
                        }
                    )
                }

                if (
                    item &&
                    item.def_dossier_def_field &&
                    item.def_dossier_def_field.def_field &&
                    item.def_dossier_def_field.def_field.settings
                ) {
                    item.def_dossier_def_field.def_field.settings.current_time_as_default = false
                }
            })
        }
        return (
            <Row
                className={
                    this.props.custom_layout === 'row_input'
                        ? 'd-flex justify-content-between align-items-baseline'
                        : ''
                }
                style={{ margin: '0 -10px' }}
            >
                {this.state.confirmRedirect ? <ConfirmRedirectWebpageDialog kedo={this.props.kedo} accept={() => {
                    window.open(this.state.confirmRedirect, '_blank');
                    this.setState({confirmRedirect: null})
                }} cancel={() => this.setState({confirmRedirect: null})} /> : null}

                {this.state.editDdl ? (
                    <DefDossierLinkForm
                        defDossier={this.state.editDdl.def_dossier_id}
                        onClose={() => this.setState({ editDdl: false })}
                        item={this.state.editDdl.def_dossier_link}
                        kedo={this.props.kedo}
                        onSuccess={() => {
                            this.setState({ editDdl: false })
                            this.props.fetch()
                        }}
                    />
                ) : null}
                {this.state.editDdi ? (
                    <DisplayItemForm
                        defDossier={this.state.editDdi.def_dossier_id}
                        onClose={() => {
                            this.setState({ editDdi: false })
                            this.props.fetch()
                        }}
                        id={this.state.editDdi.id}
                        kedo={this.props.kedo}
                    />
                ) : null}
                {this.state.editDddf ? (
                    <DefDossierDefFieldForm
                        defDossier={this.state.editDddf.def_dossier_id}
                        onClose={() => {
                            this.setState({ editDddf: false })
                            this.props.fetch()
                        }}
                        item={this.state.editDddf.def_dossier_def_field}
                        kedo={this.props.kedo}
                    />
                ) : null}
                {this.state.editDf ? (
                    <DefFieldForm
                        defDossier={this.state.editDf.def_dossier_id}
                        onClose={() => {
                            this.setState({ editDf: false })
                            this.props.fetch()
                        }}
                        item={this.state.editDf.def_dossier_def_field.def_field}
                        kedo={this.props.kedo}
                    />
                ) : null}
                {this.renderDisplayItems(this.state.firstcheck)}
                {this.props.customButtons ? this.props.customButtons() : null}
            </Row>
        )
    }
}

export default DefaultGrid
